export enum TagMemberSize {
  XS = 'xs',
  SM = 'sm',
  RG = 'rg',
  MD = 'md',
}

export enum TagMemberType {
  Rappi = 'rappi',
  Pro = 'pro',
  Pay = 'pay',
  RappiCard = 'rappi-card',
  Marriott = 'marriott',
}

export enum TagMemberStyle {
  Member = 'member',
  Strikethrough = 'strikethrough',
}

export interface TagMemberStrikethrough {
  Value: string;
  Align: 'left' | 'right';
  ShowIcon: boolean;
}

export type TagMemberSliced = 'horizontal-left' | 'vertical-top' | 'rounded-branding';
